import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { AdalService } from 'app/services/adal.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  password: string;
  userName: string;
  errorMsg: string;

  constructor(private auth : AuthService, private adalService : AdalService) {
    this.adalService.login();
   }

  ngOnInit() {
    
  }

  login(){
    //this.auth.login(this.userName, this.password);
    //this.auth.errorMessage

    //this.adalService.login();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts